module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "m-l-50 m-t-30 w-500"
  }, [_c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.form,
      "rules": _vm.rules,
      "label-width": "180px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "系统名称",
      "prop": "SYSTEM_NAME"
    }
  }, [_c('el-input', {
    staticClass: "h-40 w-200",
    model: {
      value: (_vm.form.SYSTEM_NAME),
      callback: function($$v) {
        _vm.$set(_vm.form, "SYSTEM_NAME", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "form.SYSTEM_NAME"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "LOGO"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "150px",
      "height": "40px"
    },
    attrs: {
      "src": _vm.form.SYSTEM_LOGO
    }
  }), _vm._v(" "), _c('el-upload', {
    attrs: {
      "action": _vm.uploadUrl,
      "type": "drag",
      "thumbnail-mode": true,
      "on-preview": _vm.viewPic,
      "on-remove": _vm.handleRemove,
      "on-success": _vm.uploadSuccess,
      "on-error": _vm.uploadFail,
      "show-file-list": false
    }
  }, [_c('i', {
    staticClass: "el-icon-upload"
  }), _vm._v(" "), _c('div', {
    staticClass: "el-dragger__text"
  }, [_vm._v("将文件拖到此处，或"), _c('em', [_vm._v("点击上传")])]), _vm._v(" "), _c('div', {
    staticClass: "el-upload__tip",
    attrs: {
      "slot": "tip"
    },
    slot: "tip"
  }, [_vm._v("只能上传jpg/png文件")])])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "LOGO类型"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.form.LOGO_TYPE),
      callback: function($$v) {
        _vm.$set(_vm.form, "LOGO_TYPE", $$v)
      },
      expression: "form.LOGO_TYPE"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "1"
    }
  }, [_vm._v("图片")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "2"
    }
  }, [_vm._v("文字")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "登录验证码"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.form.IDENTIFYING_CODE),
      callback: function($$v) {
        _vm.$set(_vm.form, "IDENTIFYING_CODE", $$v)
      },
      expression: "form.IDENTIFYING_CODE"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "1"
    }
  }, [_vm._v("打开")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "0"
    }
  }, [_vm._v("关闭")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "登录会话有效期(秒)",
      "prop": "LOGIN_SESSION_VALID"
    }
  }, [_c('el-input', {
    staticClass: "h-40 w-200",
    model: {
      value: (_vm.form.LOGIN_SESSION_VALID),
      callback: function($$v) {
        _vm.$set(_vm.form, "LOGIN_SESSION_VALID", _vm._n($$v))
      },
      expression: "form.LOGIN_SESSION_VALID"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "小程序",
      "prop": "APPLET_URL"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "150px",
      "height": "150px"
    },
    attrs: {
      "src": _vm.form.APPLET_URL
    }
  }), _vm._v(" "), _c('el-upload', {
    staticClass: "avatar-uploader",
    attrs: {
      "type": "drag",
      "action": _vm.uploadUrl,
      "show-file-list": false,
      "on-success": _vm.handleAvatarSuccess
    }
  }, [_c('i', {
    staticClass: "el-icon-upload"
  }), _vm._v(" "), _c('div', {
    staticClass: "el-dragger__text"
  }, [_vm._v("将文件拖到此处，或"), _c('em', [_vm._v("点击上传")])]), _vm._v(" "), _c('div', {
    staticClass: "el-upload__tip",
    attrs: {
      "slot": "tip"
    },
    slot: "tip"
  }, [_vm._v("只能上传jpg/png文件")])])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "官网地址",
      "prop": "HOME_URL"
    }
  }, [_c('el-input', {
    staticClass: "h-40 w-200",
    model: {
      value: (_vm.form.HOME_URL),
      callback: function($$v) {
        _vm.$set(_vm.form, "HOME_URL", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "form.HOME_URL"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.isLoading,
      "size": "small"
    },
    on: {
      "click": function($event) {
        return _vm.add()
      }
    }
  }, [_vm._v("提交")])], 1)], 1), _vm._v(" "), _c('preview', {
    ref: "preview",
    attrs: {
      "url": _vm.propsImg
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4a5ad52f!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Administrative/system/config/add.vue
// module id = 1839
// module chunks = 2